import React from "react";
import checkboxIcon from "../../assets/icons/checkbox_icon.svg"
import Button from "../Buttons";
import LoadSpinner from "../LoadingSpinner";

interface PricingCardProps {
    packageName: string,
    unitAmount: string
    metadata: { [key: string]: string }
    index: number,
    description: string
    packageHandler: (index: number) => void
    isLoading?: boolean
}


const PricingCard: React.FC<PricingCardProps> = ({
    packageName,
    unitAmount,
    metadata,
    index,
    description,
    packageHandler,
    isLoading
}) => {


    return (
        <div className="relative bg-white overflow-hidden rounded-3xl w-full md:w-[380px] shadow-2xl md:shadow-lg p-[35px] h-[511px] mb-10 lg:mb-0">
            {index === 1 && <div className="!bg-[#23FF9C] text-[12px] rounded-lg rounded-t-none rounded-r-none right-0 top-0 p-3 absolute">Recommended</div>}
            <div className="min-h-[375px]">
                <div className="mb-4">
                    <p className="text-[14px] font-medium">Starting at</p>
                    {index === 0 ? <h2 className="text-[28px] font-semibold mb-8 w-fit">Free</h2> :
                        <h2 className="text-[28px] font-semibold mb-8">${unitAmount}<span className="text-[14px] font-medium">/Month</span></h2>
                    }
                    <h3 className="text-[22px] font-medium mb-2">{packageName} Plan</h3>
                    <p className="text-[14px]">{description}</p>
                </div>
                <hr className="border border-[#232323]" />
                <div className="mt-4 mb-5">
                    <h3 className="text-[14px] font-medium mb-4">Key Features</h3>
                    <ul>
                        {metadata && Object.keys(metadata)?.map((item: any, index: number) => <li key={index} className="flex items-start mb-2 gap-3 text-[16px]">
                            <img src={checkboxIcon} alt="checkbox" />
                            {item}</li>)
                        }
                    </ul>
                </div>
            </div>
            <div className="mt-[25px] relative">
                {index === 1 &&  isLoading && <LoadSpinner
                    classes="absolute bottom-0"
                />}
                <Button
                    btn_label={index === 0 ? "Continue with your free trial" : "Get it now"}
                    type={index === 1 ? "primary" : "secondary"}
                    is_disable={isLoading}
                    on_click_handler={() => packageHandler(index)}
                    other_classes={`!text-[14px] ${index === 1 ? "!bg-[#23FF9C] !text-[#232323]" : "!bg-[#F5F5F5] !text-[#000000]"}`}
                />
            </div>
        </div>
    )
}

export default PricingCard;